// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Applications: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 29 42" enableBackground="new 0 0 29 42" xmlSpace="preserve" fill="currentColor">
<path d="M9.8,15l3.7,4.5l4.7-4.4c0,0-1.7-2.1-3.3-4.3c0.5-1,0.7-2.1,0.7-3.3c0-0.5-0.2-1.1-0.2-1.1L5.7,9.2L2.9,1.8
	c0,0-0.3,0.2-0.4,0.4C1.2,3.6,0.3,5.5,0.3,7.6c0,4.2,3.4,7.6,7.6,7.6C8.6,15.2,9.2,15.2,9.8,15z"/>
<path d="M15,4.7c-0.9-2.4-3.1-4.1-5.7-4.2c-0.1,0-0.4,0-0.4,0l1.7,5.5C10.5,5.9,15,4.7,15,4.7z"/>
<path d="M27.6,26.3c0,0,1.7-2.1-1.5-3.9c0-0.9,0.4-3.3-2.5-3.6c0-0.2,0.3-1.3-0.2-2.3c-0.5-0.8-1.6-1.6-2.8-1
	c-2.5,1.3-6.1,5.9-6.1,5.9s-2.6-2-4.8-0.2c-2,1.7-1.6,7.3-1.6,7.3s-0.1,3.6-3.3,6l7.1,7.1c0,0,1.2-2.1,5.7-3.8
	c4.5-1.6,8.8-4.2,10.4-7.1C29.8,27.9,27.6,26.3,27.6,26.3z"/>
</svg>;
};

export default React.memo(Applications);
